import React from "react";
import { Link } from "react-router-dom";
import "./articleCard.css";
import NavigateIcon from "./assets/navigateIcon.png";

const ArticleCard = ({ article }) => {
  return (
    <Link to={`/article/${article.id}`} className="ac-link">
      <div className="ac-card">
        <div className="ac-image-container">
          <img
            src={article.displayImage}
            alt={article.title}
            className="ac-card-image"
          />
          <div className="ac-card-overlay">
            <div className="ac-card-details">
              <div className="ac-author-block">
                <span className="ac-author-name">{article.author}</span>
                <span className="ac-author-date">{article.date}</span>
              </div>
              <span className="ac-category">{article.category}</span>
            </div>
          </div>
        </div>
        <div className="ac-card-body">
          <p className="ac-body-title">{article.title}</p>
          <p className="ac-body-description">{article.introduction}</p>
          <div className="ac-redirect">
            <span>Read Post</span>
            <img
              src={NavigateIcon}
              alt="navigate"
              className="ac-redirect-icon"
            />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ArticleCard;
